import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import _ from "lodash";

import {
  set_challenge_details,
  set_challenge_entries,
  set_user_challenges
} from "redux/challenges/action";
import Socket from "socket";
import { setIsLoading } from "redux/loader/action";
import CardHome from "./components/CardHome";
import useWindowDimensions from "shared/helpers/getWindowDimensions";

const Challenges = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();
  const {
    gameReducer: { mobile_app, currentUser },
    challengesReducer: { user_challenges },
    paramsReducer
  } = useSelector((state) => state);

  const main_params = _.get(
    paramsReducer,
    "paramsObj.mobile_website.challenges.main"
  );
  const label = _.get(main_params, "label", "Team Challenges");
  const text = _.get(
    main_params,
    "text",
    "Group challenges to engage with your teammates!"
  );

  const handleSetIsLoading = (value) => {
    dispatch(setIsLoading(value));
  };

  useEffect(() => {
    return Socket.addListener(
      "challenge-get",
      handle_challenge_get,
      handle_challenge_get_error
    );
  }, []);

  const handle_challenge_get = (res) => {
    if (res) {
      let filtered_challenges = res.user_challenges
        .filter(
          (item) =>
            !item.archived &&
            moment(item.start_date) < moment() &&
            moment(item.end_date).isSameOrAfter(moment().format("MM/DD/YYYY"))
        )
        .sort((a, b) => moment(a.end_date) - moment(b.end_date));
      handleSetIsLoading(false);
      dispatch(set_user_challenges(filtered_challenges));
    }
  };
  const handle_challenge_get_error = (err) => {
    handleSetIsLoading(false);
  };

  useEffect(() => {
    handleSetIsLoading(true);
    const data = {
      action: "challenge-get",
      table: ["userChallenges"],
      team_code: currentUser.team_code,
      user_id: currentUser.userId
      // team_code: "teamCode",
      // user_id: "1"
    };
    Socket.sendMessage(data);
  }, []);

  useEffect(() => {
    dispatch(set_challenge_details({}));
    dispatch(set_challenge_entries([]));
  }, []);

  return (
    <div className="challenges-wrapper">
      {!_.isEmpty(user_challenges) ? (
        <div className="challenges-home">
          <h2 className="title">{label}</h2>
          <p className="description">{text}</p>
          <div
            className="card-home-wrapper"
            style={{
              maxHeight: `${mobile_app ? height - 127 : height - 187}px`
            }}
          >
            {user_challenges.map((value, index) => (
              <CardHome
                key={index}
                challenge={value}
                history={history}
                main_params={main_params}
              />
            ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Challenges;
